import React, { useCallback, useEffect, useState } from 'react';
import { OrderArticle } from '@abm-international/react-components';
import { useDispatch, useSelector } from 'react-redux';
import {
	selectOrderQuantityByProductId,
	selectAwardedPromoByProductId,
	selectDeliveryDate,
	selectIgnoreMadQuantityById,
	selectOrderQuantityTimestampByProductId,
	selectActivePromoByProductId,
	selectEobDetailsById,
	selectProductPointsById,
	selectPermissions,
	selectOrderDisabledPromosOnArticle,
	selectOrderOverstockOnArticle,
	selectOrderDiscountOnArticle
} from '../../selectors';
import {
	disablePromo, saveOrderIfNeeded, updateProductQuantity, setOverstockOnArticle, setDiscountOnArticle
} from '../../order/orderActions';
import QuantityInput from '../CommonQuantityInput';
import { PERMISSIONS } from '../../../libraries/permissions';
// import { de } from 'date-fns/locale';
// import { tradeFairDates } from '../../../constants';
// import { useProductPoints } from '../../../libraries/hooks/useProductPoints';




function OrderArticleContainer(props) {
	const { product: { id } } = props;
	const dispatch = useDispatch();
	const awardedPromo = useSelector(state => selectAwardedPromoByProductId(state, id));
	const eobDetail = useSelector(state => selectEobDetailsById(state, id));
	const quantity = useSelector(state => selectOrderQuantityByProductId(state, id));
	const quantityTimestamp = useSelector(state => selectOrderQuantityTimestampByProductId(state, id));
	const deliveryDate = useSelector(selectDeliveryDate, (a, b) => a.getTime() === b.getTime());
	const ignoreMadQuantity = useSelector(state => selectIgnoreMadQuantityById(state, id));
	const [showMadQuantityWarning, setShowMadQuantityWarning] = useState(false);
	const promo = useSelector(state => selectActivePromoByProductId(state, id, props.deliveryDate));
	const tempNotAvailable= props?.product?.tempNotAvailable;
	const updateQuantity = useCallback(quantity => {
		dispatch(updateProductQuantity(props.product, quantity, promo));
	}, [dispatch, props.product, promo]);

	const permissions = useSelector(selectPermissions);
	const disabledPromo = useSelector(state => selectOrderDisabledPromosOnArticle(state, id)) ; //todo dpc
	const updateDisabledPromo = useCallback(() => {
		dispatch(disablePromo(props.product, promo));
		dispatch(saveOrderIfNeeded());
	}, [dispatch, props.product, promo]);
	const overstockOnArticle = useSelector(state => selectOrderOverstockOnArticle(state, id));
	const updateOverstock = useCallback((overstock) => {
		dispatch(setOverstockOnArticle(props.product, overstock, promo));
		dispatch(saveOrderIfNeeded());
	}, [dispatch, props.product, promo]);

	const discountOnArticle = useSelector(state => selectOrderDiscountOnArticle(state, id));
	const updateDiscount = useCallback((discount) => {
		dispatch(setDiscountOnArticle(props.product, discount, promo));
		dispatch(saveOrderIfNeeded());
	}, [dispatch, props.product, promo]);


	//const points = useSelector(state => selectProductPointsById(state, id));
	// const productPoints = useProductPoints(
	// 	points,
	// 	deliveryDate,
	// 	tradeFairDates,
	// );

	const isComocatFase1 = permissions?.includes(PERMISSIONS.COMOCAT_FASE_1);

	useEffect(() => {
		const getShowMadQuantity = (amount, tolerated, ignore) => {
			if (!amount) return;
			if (tolerated === null) return;
			if (ignore) return;
			if (quantity < tolerated) return;
			if (Boolean(ignore)) return;
			return true;
		};

		const mq = Boolean(getShowMadQuantity(quantity, +props.product.madQuantity, ignoreMadQuantity));
		if (mq !== showMadQuantityWarning) setShowMadQuantityWarning(mq);
	}, [props.product.madQuantity, ignoreMadQuantity, quantity, showMadQuantityWarning, disabledPromo, overstockOnArticle]);

	const xx = props.product?.overstock?.map(item => {
		if (
			overstockOnArticle &&
			overstockOnArticle.osp_tht &&
			item.tht == overstockOnArticle.osp_tht
		) {
			return { ...item, osp_status: overstockOnArticle.osp_status };
		}
		return item;
	});

	return (
		<OrderArticle
			{...props}
			updateProductQuantity={updateQuantity}
			deliveryDate={deliveryDate}
			awardedPromo={disabledPromo > 0 ? null : awardedPromo}
			showMadQuantityWarning={showMadQuantityWarning}
			quantity={quantity}
			quantityTimestamp={quantityTimestamp}
			QuantityInput={QuantityInput}
			hideQuantityInput={tempNotAvailable ? tempNotAvailable: false}
			tempNotAvailable={tempNotAvailable}
			backAvailableFrom={props.product?.backAvailableFrom}
			product={{
				...props.product,
				// TODO: props.product.allergens can be "false", should be array or undefined -> where is allergens set??
				allergens: props.product.allergens || [],
				madQuantity: props.product.madQuantity ? Number(props.product.madQuantity) : 1000,
				promo,
				name: `${props.product.name}${isComocatFase1 ? ` / €${Number(props.product.price).toFixed(2)}` : ''}`,
				abcAssortmentcode: props.product.abcAssortmentCode || null
			}}
			eobDetail={eobDetail}
			discount={discountOnArticle}
			setDiscount={updateDiscount}
			// disabledPromo={disabledPromo>0}
			// setDisabledPromo={updateDisabledPromo}
			{...(permissions?.includes(PERMISSIONS.COMOCAT_FASE_1)
            ? {
            	disabledPromo: disabledPromo > 0,
            	setDisabledPromo: updateDisabledPromo,
            	overstock: xx ?? null,
            	setOverstock: updateOverstock,
            	showDiscount: true,
            	discountDisabled: overstockOnArticle?.osp_status === 'O',
            	overstockDisabled: discountOnArticle?.quantity > 0
            }
            : {})}

			// points={{
			// 	normal: productPoints.standardPoints,
			// 	// tradeFair: productPoints.tradeFairPoints
			// }}
			// {...(
			//     TODOPERMISSIONCOMOCAT ? {disabledPromo={disabledPromo},
			//     setDisabledPromo={() => setDisabledPromo(prev => !prev)}} : {}
			// )}
		/>
	);
}

export default React.memo(OrderArticleContainer, (a, b) => {
	if (a.product.id !== b.product.id) return false;
	if (a.product.name !== b.product.name) return false;
	if (a.view !== b.view) return false;
	if (a.sizes.length !== b.sizes.length) return false;
	if (a.history === undefined && b.history !== undefined) return false;
	return true;
});
